/**
 * Cria as duas opções fixas da resposta dicotômica na ordem exibida pela UI.
 */
export const createOpcoesDicotomicas = () => [
  { id: 'nao', opcao: 'Não', pergunta: 'Não', discriminacao: '', points: -3, rating: 1 },
  { id: 'sim', opcao: 'Sim', pergunta: 'Sim', discriminacao: '', points: -3, rating: 1 }
];

const pvParseRespostaNota = pValor => {
  const xNumero = Number(pValor);
  return Number.isFinite(xNumero) ? xNumero : -3;
};

const pvNormalizarLabel = pLabel => String(pLabel || '')
  .trim()
  .toLowerCase();

/**
 * Hidrata as opções dicotômicas preservando a ordem visual `Não` -> `Sim`.
 * Prioriza o label do payload e usa o índice apenas como fallback.
 */
export const mapRespostaDominioToOpcoesDicotomicas = (pRespostaDominio = []) => {
  const xOpcoesBase = createOpcoesDicotomicas();
  const xRespostaDominio = Array.isArray(pRespostaDominio) ? pRespostaDominio : [];

  const xItensPorId = xRespostaDominio.reduce((pAcc, pItem, pIndex) => {
    const xLabel = pvNormalizarLabel(pItem?.label);

    if (xLabel === 'não' || xLabel === 'nao') {
      pAcc.nao = pItem;
      return pAcc;
    }

    if (xLabel === 'sim') {
      pAcc.sim = pItem;
      return pAcc;
    }

    if (!pAcc.nao && pIndex === 0) {
      pAcc.nao = pItem;
      return pAcc;
    }

    if (!pAcc.sim && pIndex === 1) {
      pAcc.sim = pItem;
    }

    return pAcc;
  }, {});

  return xOpcoesBase.map(pOpcao => {
    const xApiItem = xItensPorId[pOpcao.id];

    return {
      ...pOpcao,
      discriminacao: (xApiItem?.objetivo || '').trim(),
      points: pvParseRespostaNota(xApiItem?.nota)
    };
  });
};

/**
 * Serializa o formulário dicotômico mantendo a mesma ordem exibida na UI.
 */
export const mapOpcoesDicotomicasToRespostaDominio = (pOpcoesDicotomicas = []) => {
  return (Array.isArray(pOpcoesDicotomicas) ? pOpcoesDicotomicas : []).map((pOpcao, pIndex) => ({
    id: pIndex + 1,
    label: pOpcao.pergunta,
    tooltip: '',
    objetivo: (pOpcao.discriminacao || '').trim(),
    valor: pIndex,
    nota: Number(pOpcao.points)
  }));
};
